import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'momentPipe'
})
/**
 * Converts a UTC Date Time (or dateless GMT datetime object) to browser local time
 */
export class MomentPipe implements PipeTransform {
    private debug: boolean = false;
    private logFormat: string = "background:lightgray; color:#0a0063;";
    transform(value: Date | moment.Moment, ...args: any[]): any {
        let [format] = args;
        if (this.debug) { console.log('%cMoment Pipe Format Given: ', this.logFormat, format); }
        if (this.debug) { console.log("%cMoment Pipe Time Given: ", this.logFormat, value); }
        if (this.debug) { console.log("%cMoment Pipe Local Time: ", this.logFormat, moment.utc(value).local()); }
        if (format == 'fromNow') {
            return moment.utc(value).local().fromNow();
        }
        return moment.utc(value).local().format(format);
    }
}